(function () {
  var p = location.pathname;
  if (p.indexOf('/checkout') === 0 || p.indexOf('/cart') === 0) return;
  if (!window.Shopify || !Shopify.country) return;

  // Уже на украинском рынке → чистим флаг и выходим
  if (Shopify.country === 'UA') {
    try { sessionStorage.removeItem('ua_switching'); } catch (e) {}
    return;
  }

  // В этой сессии мы уже выяснили, что посетитель НЕ из Украины (США и т.д.) —
  // не дёргаем геолокацию на каждой странице, просто оставляем его рынок как есть.
  try {
    if (sessionStorage.getItem('geo_not_ua') === '1') return;
  } catch (e) {}

  // Анти-цикл: если только что пытались переключить, а рынок всё ещё не UA — стоп,
  // чтобы не крутить reload по кругу.
  try {
    if (sessionStorage.getItem('ua_switching')) {
      sessionStorage.removeItem('ua_switching');
      return;
    }
  } catch (e) {}

  // Определяем РЕАЛЬНОЕ местоположение по IP
  fetch('/browsing_context_suggestions.json', { headers: { Accept: 'application/json' } })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      var detected =
        data && data.detected_values && data.detected_values.country
          ? data.detected_values.country.handle
          : null;

      // Посетитель НЕ из Украины → НЕ трогаем, запоминаем на сессию
      if (detected !== 'UA') {
        try { sessionStorage.setItem('geo_not_ua', '1'); } catch (e) {}
        return;
      }

      // Посетитель ИЗ Украины, но рынок не UA → форсим UA
      try { sessionStorage.setItem('ua_switching', '1'); } catch (e) {}

      var style = document.createElement('style');
      style.textContent = 'html{visibility:hidden!important}';
      (document.head || document.documentElement).appendChild(style);

      fetch('/localization', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: 'form_type=localization&_method=put&country_code=UA&return_to=' +
          encodeURIComponent(location.pathname + location.search)
      })
        .then(function () { location.reload(); })
        .catch(function () {
          try { sessionStorage.removeItem('ua_switching'); } catch (e) {}
          style.remove();
        });
    })
    .catch(function () {
      // геолокация недоступна → ничего не форсим (безопасный дефолт)
    });
})();